var scope_0 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/051be3ffc0be2dbf08d44859da2b3cd0.js').default;
var scope_1 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/15d2b5400af6cc6c3bf8dddf3b340b2d.js').default;
var scope_2 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1ba9eb4d2afd3f73b2ff01713160a7a3.js').default;
var scope_3 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1e0cd75960662c72d97fcd59c1010439.js').default;
var scope_4 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3a4fce44fa445fb41eddfea4a340d55c.js').default;
var scope_5 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3f18f96e008d56012c6431ce86052329.js').default;
var scope_6 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4788502a38c8fcd4c583f942b7778155.js').default;
var scope_7 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4961b3b6977eb4779be1c6306b616f7c.js').default;
var scope_8 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/56f63ac2b5db3b1902083e3fb6ab45b3.js').default;
var scope_9 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/57833d27cc80a478ddabf67bed0e1851.js').default;
var scope_10 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/59e21610ffeb9c09b72c6ce046674231.js').default;
var scope_11 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/70814dfd93ad1448b1f2c76593314e56.js').default;
var scope_12 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/72bd09d2d419055a589a5601bfb41908.js').default;
var scope_13 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7418f5c3ed6b43f355272f7e16cad141.js').default;
var scope_14 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/75a3cff04c2548134d2a0694d5921082.js').default;
var scope_15 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/808c3a32479041fdd7377cc1429c9e1c.js').default;
var scope_16 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ae6faa4402ae78c063156a724342f0a.js').default;
var scope_17 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b34e513ca5af2ae508b4d9c09178580c.js').default;
var scope_18 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c575b27a10fb5e2b2031999c5485c043.js').default;
var scope_19 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c723e597fe9ee84169dd17bc3b6b8c4e.js').default;
var scope_20 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dcc906c1221f937ffb3a2c2399dd7c2c.js').default;
var scope_21 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e70424bde63f9442d56288caffa0c88f.js').default;
var scope_22 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_23 = require('/builds/frontend/chameleon-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f9063955ec5d38b9070a20411ea7995a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21,
scope_22,
scope_23 )
    